export interface Reminder {
  id: string;
  user_id: number;
  type: 'tension' | 'headache' | 'medication';
  title: string;
  message: string;
  time: string; // HH:MM format
  start_date: string;
  end_date?: string;
  frequency: 'once' | 'daily' | 'weekly' | 'monthly' | 'custom';
  days_of_week?: number[]; // 0=Sunday, 1=Monday, etc. For weekly/custom
  days_of_month?: number[]; // 1-31, for monthly
  notification_methods: string[]; // Array: ['push'], ['email'], ['both']
  enabled: boolean; // Cambiado de is_active a enabled
  created_at: string;
  updated_at: string;
  last_sent?: string; // Cambiado de last_sent_at
  next_send: string; // Cambiado de next_send_at
}

export interface ReminderFormData {
  type: 'tension' | 'headache' | 'medication';
  title: string;
  message: string;
  time: string;
  frequency: 'once' | 'daily' | 'weekly' | 'monthly' | 'custom';
  days_of_week?: number[];
  days_of_month?: number[];
  notification_method: 'push' | 'email' | 'both';
  is_active: boolean; // Mantener para compatibilidad con el formulario
}

export interface ReminderTemplate {
  id: string;
  type: 'tension' | 'headache' | 'medication';
  title: string;
  message: string;
  icon: string;
  color: string;
}

export const REMINDER_TEMPLATES: ReminderTemplate[] = [
  {
    id: 'tension_morning',
    type: 'tension',
    title: 'Medir tensión matutina',
    message: '🌅 Buenos días! Es hora de medir tu tensión arterial matutina.',
    icon: '💓',
    color: '#ef4444'
  },
  {
    id: 'tension_evening',
    type: 'tension',
    title: 'Medir tensión nocturna',
    message: '🌙 Es hora de tu medición nocturna de tensión arterial.',
    icon: '💓',
    color: '#8b5cf6'
  },
  {
    id: 'tension_custom',
    type: 'tension',
    title: 'Recordatorio de tensión',
    message: '💓 No olvides medir tu tensión arterial.',
    icon: '💓',
    color: '#06b6d4'
  },
  {
    id: 'headache_check',
    type: 'headache',
    title: 'Registro diario de dolores',
    message: '🤕 ¿Has tenido algún dolor de cabeza hoy? Regístralo para un mejor seguimiento.',
    icon: '🤕',
    color: '#f59e0b'
  },
  {
    id: 'medication_reminder',
    type: 'medication',
    title: 'Recordatorio de medicación',
    message: '💊 Es hora de tomar tu medicación. No olvides registrarla.',
    icon: '💊',
    color: '#10b981'
  }
];